import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/shipping-policy")({
  head: () => ({
    meta: [
      { title: "Delivery & Shipping Policy - DeckScore" },
      { name: "description", content: "How DeckScore delivers its digital services." },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Delivery & Shipping Policy - DeckScore" },
      { property: "og:description", content: "How DeckScore delivers its digital services." },
    ],
  }),
  component: ShippingPolicy,
});

function ShippingPolicy() {
  return (
    <LegalPage title="Delivery & Shipping Policy">
      <p><strong>Delivery &amp; Shipping Policy</strong></p>
      <p><strong>Effective Date: 11 July 2026</strong></p>
      <p>
        DeckScore provides digital services only - AI pitch-deck analysis and investor-introduction outreach. As such, there is no physical product involved, and no shipping or physical delivery applies.
      </p>
      <p>
        Free pitch-deck analysis is delivered instantly (or within a few minutes) on-screen and/or via email after you submit your deck.
      </p>
      <p>
        For paid investor-introduction services, once your payment is successfully completed, we begin preparing your one-pager and initiate investor outreach as per the service schedule. Outreach and confirmation details are shared via email, typically within 48 hours.
      </p>
      <p>
        If you do not receive your analysis or service-related details within the expected timeframe, please contact us at <a href="mailto:info@ikomatch.com">info@ikomatch.com</a> for assistance.
      </p>
    </LegalPage>
  );
}
